<template>
  <div class="default-border-radius table-responsive p-3 pt-0 pb-0 bg-white">
    <q-table
      :rows="histories"
      :columns="columns"
      row-key="name"
      hide-pagination
      class="shadow-0 table table-sm bg-white mb-0"
    >

      <!-- update labels mechanism -->
      <template v-slot:header="props">
        <q-tr :props="props">
          <q-th v-for="col in props.cols" :key="col.name" :props="props">
            <template v-if="col.name !== 'actions'">{{ $t(col.label) }}</template>
          </q-th>
          <q-th auto-width />
        </q-tr>
      </template>

      <template v-slot:no-data="{ icon, message, filter }">
        <div class="text-deep-orange-4 font-size-12 font-medium">
          <span> {{ $t("task.historiesStep.headers.histories.noDataMessage") }} </span>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { formatDate } from "@/utils/configuration/formatters-config";
import { globalConfig } from "@/utils";

@Options({
  components: { },
  props: ["histories"],
})
export default class OrderHistoryPanel extends Vue {
  histories?: [];

  columns = globalConfig.table_config.orderHistoryTableCols.histories;
}
</script>

<style scoped></style>
